import React from "react";
import { Stack } from "@mui/material";
import RequestDetailsGrid from "./RequestDetailsGrid";
import OutOfRequestServicesGrid from "./OutOfRequestServicesGrid";
import { useTranslate } from "src/locales";
import type { RequestDetailRow } from "../types";

interface PendingRequestsTabProps {
  requestDetails: RequestDetailRow[];
  outOfRequestServices: RequestDetailRow[];
  loading?: boolean;
  currentUser?: string;
  ptId?: string | number;
  onRefresh?: () => void;
}

export default function PendingRequestsTab({
  requestDetails,
  outOfRequestServices,
  loading = false,
  currentUser = "",
  ptId,
  onRefresh,
}: PendingRequestsTabProps) {
  const { t } = useTranslate();

  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      <RequestDetailsGrid
        rows={requestDetails}
        loading={loading}
        menuVariant="request-details"
        title={t("request-list.request-details", "default", {
          defaultValue: "İstek Detayları",
        })}
        currentUser={currentUser}
        ptId={ptId}
        onRefresh={onRefresh}
      />
      <OutOfRequestServicesGrid
        rows={outOfRequestServices}
        loading={loading}
      />
    </Stack>
  );
}
